import React from 'react';

import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../../../components/form/form-field';
import SaveButton from '../../../../../components/form/save-button';

const DedupTaskForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;

  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="dedupTaskFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={errors.name?.message}
      />
      <FormField
        controlId="dedupTaskFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors.type?.message}
      />
      <FormField
        controlId="dedupTaskFormFunction"
        label="function"
        name="function"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors.function?.message}
        defaultValue="dedup"
      />
      <FormField
        controlId="dedupTaskFormInputData"
        label="inputData"
        name="parameters.inputData"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter input data"
        required
        error={errors.parameters?.inputData?.message}
      />
      <FormField
        controlId="dedupTaskFormTargetData"
        label="targetData"
        name="parameters.targetData"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter target data"
        required
        error={errors.parameters?.targetData?.message}
      />
      <FormField
        controlId="dedupTaskFormRecordType"
        label="recordType"
        name="parameters.recordType"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter record type"
        required
        error={errors.parameters?.recordType?.message}
      />
      <FormField
        controlId="dedupTaskFormDuplicateOutputName"
        label="duplicateOutputName"
        name="parameters.duplicateOutputName"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter duplicate output name"
        error={errors.parameters?.duplicateOutputName?.message}
      />
      <FormField
        controlId="dedupTaskFormDedupResult"
        label="dedupResult"
        name="parameters.dedupResult"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter dedup result"
        error={errors.parameters?.dedupResult?.message}
      />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default DedupTaskForm;
